const getSrpUrlParams = flightSearchData => {
  const { source, destination, departure, arrival, passengers, flightClass, travelType } =
    flightSearchData;
  const EMPTY_STRING = '';
  const DOMESTIC = 'domestic';
  const DOMESTIC_TYPE = 'D';
  const INTERNATIONAL_TYPE = 'I';
  return `${source.iata}-${destination.iata}-${departure.yyyymmdd}-${
    arrival ? arrival.yyyymmdd : EMPTY_STRING
  }-${passengers.adult}-${passengers.child}-${passengers.infant}-${flightClass.value}-${
    travelType === DOMESTIC ? DOMESTIC_TYPE : INTERNATIONAL_TYPE
  }`;
};

export default getSrpUrlParams;
